import { Button } from 'components/atoms';
import { PublicPage } from 'components/templates';
import { useResetPasswordNavigation } from 'hooks';
import { Trans, useTranslation } from 'react-i18next';
import { PiConfetti } from 'react-icons/pi';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const ResetPasswordConfirmation = () => {
  const { t } = useTranslation();

  const { goToLogin, email } = useResetPasswordNavigation();

  return (
    <PublicPage
      header={
        <div className='flex gap-4  items-center'>
          <PiConfetti size={50} />
          <p className='text-lg font-semibold'>
            {t('confirm-email.creative.header')}
          </p>
        </div>
      }>
      <p className='text-center'>
        <Trans
          i18nKey='reset-password-confirmation.message'
          values={{ email: email }}
          components={{ strong: <strong /> }}
        />
      </p>
      <div />
      <div />
      <Button variant={BUTTON_VARIANT.submit} onClick={goToLogin}>
        <Button.Text text={t('reset-password-confirmation.button')} />
      </Button>
    </PublicPage>
  );
};

export default ResetPasswordConfirmation;
